import { render, staticRenderFns } from "./TabelaHome.vue?vue&type=template&id=334de6fa&scoped=true&"
import script from "./TabelaHome.vue?vue&type=script&lang=js&"
export * from "./TabelaHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334de6fa",
  null
  
)

export default component.exports